import { useEffect } from 'react';
import { addInterceptors } from './config/codegen';
import { configureSwaggerApi } from './config/SwaggerApi';
import { configureSwaggerProductReservationApi } from './config/SwaggerProductReservationApi';

const baseURL = process.env.REACT_APP_API_BASE_URL ? process.env.REACT_APP_API_BASE_URL.toString() : '';
const baseURLProductReservation = process.env.REACT_APP_PRODUCT_RESERVATION_API_BASE_URL ? process.env.REACT_APP_PRODUCT_RESERVATION_API_BASE_URL.toString() : '';

const useSwaggerApiInitialization = () => {
    useEffect(() => {
        configureSwaggerApi({
            config: {
                baseURL,
            },
            modifyInstance: (instance) => {
                addInterceptors(instance);
            },
        });
        configureSwaggerProductReservationApi({
            config: {
                baseURL: baseURLProductReservation,
            },
            modifyInstance: (instance) => {
                addInterceptors(instance);
            },
        });
    }, []);
};

export default useSwaggerApiInitialization;
